<template>
  <div>
    <a href="https://www.nih.gov/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/NIH.svg"
        alt="NIH"
        title="NIH"
        class="nih" />
      <img v-else src="./img/NIH-darkMode.svg" alt="NIH" title="NIH" class="nih" />
    </a>
    <a href="https://www.broadinstitute.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Broad.png"
        alt="Broad Institute"
        title="Broad Institute" />
      <img v-else src="./img/Broad-darkMode.png" alt="Broad Institute" title="Broad Institute" />
    </a>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
    <a href="http://www.nature.com/nmeth/" rel="nofollow">
      <img src="./img/Nature_Methods.png" alt="Nature Methods" title="Nature Methods" />
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.nih {
  max-height: calc(3.3rem * 1.4);
}
</style>
